import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { discardScanJob } from '../api/receiptsApi';

// Drop a scan-job row + its pending blob. Server broadcasts UpdateScanJobs
// so the banner refreshes automatically; no local cache invalidation here.
export default function useDiscardScanJob() {
    return useMutation({
        mutationFn: (id) => discardScanJob(id),
        onError: (err) => toast.error(err?.message ?? 'Failed to discard scan job'),
    });
}
